module.exports = __webpack_public_path__ + "img/craftsman.b9a7410.webp";